import { useMemo } from 'react'
import type { PartTone } from '@/utils/splitSuggestion'

const TONE_CELL: Record<Exclude<PartTone, null>, string> = {
  subject: 'bg-blue-100/70 text-blue-800 border-blue-200',
  room: 'bg-purple-100/70 text-purple-800 border-purple-200',
  klass: 'bg-emerald-100/70 text-emerald-800 border-emerald-200',
  ignore: 'bg-gray-100/80 text-gray-500 border-gray-200',
}

export function CharacterRuler({
  token,
  cuts,
  tones,
  onChange,
}: {
  token: string
  cuts: number[]
  tones?: Array<PartTone | null>
  onChange: (cuts: number[]) => void
}) {
  const chars = useMemo(() => [...token], [token])
  const active = useMemo(() => new Set(cuts), [cuts])

  const toggle = (after: number) => {
    const next = new Set(active)
    if (next.has(after)) next.delete(after)
    else next.add(after)
    onChange([...next].sort((a, b) => a - b))
  }

  if (!chars.length) return null

  return (
    <div className="flex items-end overflow-x-auto py-1">
      {chars.map((ch, i) => (
        <span key={`${ch}-${i}`} className="flex items-end">
          <span
            className={`flex h-7 w-[22px] items-center justify-center border font-mono text-[15px] first:rounded-l-md last:rounded-r-md ${
              tones?.[i] ? TONE_CELL[tones[i]!] : 'border-gray-200 bg-white'
            }`}
            style={{ borderRightWidth: i === chars.length - 1 ? 1 : 0 }}
          >
            {ch}
          </span>
          {i < chars.length - 1 && (
            <button
              type="button"
              className={`relative h-7 shrink-0 p-0 ${active.has(i + 1) ? 'w-1.5 bg-blue-600' : 'w-3 bg-transparent'}`}
              onClick={() => toggle(i + 1)}
              aria-label={`Schnitt nach Zeichen ${i + 1}`}
              aria-pressed={active.has(i + 1)}
            >
              <span
                className={
                  active.has(i + 1)
                    ? 'absolute inset-0 bg-blue-600'
                    : 'absolute bottom-0.5 top-0.5 left-1/2 w-0.5 -translate-x-1/2 rounded-sm bg-gray-200'
                }
              />
            </button>
          )}
        </span>
      ))}
    </div>
  )
}
